<script>
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import swal from "sweetalert";
import { UpdateLocationsGroupId } from "@/api/locations";
import DataTableSection from "@/view/components/helper/datatable/datatableSingleFetch.vue";
import AddGroupDialog from "@/view/components/locations/AddGroupDialog.vue";
import ConfirmDialog from "@/view/components/helper/popup/confirmantion.vue";

export default {
  name: "group-summary",
  components: {
    VueCtkDateTimePicker,
    DataTableSection,
    AddGroupDialog,
    ConfirmDialog
  },
  data() {
    return {
      form: {
          selectedGroups: []
      },
      searchedSelectedGroups: '',
      groupItem:[],
      groupItemCopy:[],
      searchTerm: null,
      deleteDisabled: true,
      updateGroupDisable: true,
      updateRightListDisable:true,
      updateLeftListDisable: false,
      ////////========================
      ////////========================
      selectedLocation: [],
      selectedLocationGroup: [],
      locationItem: [], // this synced below
      locationItemCopy: [],
      groupItemLocation: [],
      searchLocation: '',
      searchLocationFromGroup: '',
      locationTableDataParam: {
        getters: 'getLocations',
        dispatchFunction: 'getLocations',
        headers: [
          {
            text: "Name",
            align: "left",
            sortable: true,
            value: "name"
          },
          {text: "Street", value: "street"}
        ],
        customRenderers: []
      },
      locationByGroupNameTableDataParam: {
        getters: 'getLocationByGroup',
        dispatchFunction: 'getLocationsByGroupId',
        deleteFunction: 'deleteLocationsByGroupId',
        setQuery: 'setLocationGroupId',
        queryValue: 0,
        noItemText: 'Please select item from Location table on the left',
        headers: [
          {
            text: "Name",
            align: "left",
            sortable: true,
            value: "name"
          },
          {text: "Street", value: "street"}
        ],
        customRenderers: []
      },
      createdGroup: []
    };
  },
  computed: {
    searchTriggerLocation() {
      return this.searchLocation;
    },
    searchTriggerLocationInGroup() {
      return this.searchLocationFromGroup;
    }
  },
  async mounted() {
    await this.refreshGroupDropdown()
  },
  watch: {
    searchTriggerLocation(q) {
      let componentEvent = this.$refs.dataTableComponentOne
      componentEvent.updateSearchField(q)      
    },
    searchTriggerLocationInGroup(q) {
      let componentEvent = this.$refs.dataTableComponentTwo
      componentEvent.updateSearchField(q)      
    },
    "searchedSelectedGroups"(){
      //update the location list on left as FULL and remove the location in the group to the right
      let locationtem = [...this.locationItemCopy]
      let groupItemLocation = [...this.groupItemLocation]
      let locationList = locationtem.filter(ar => !groupItemLocation.find(rm => (rm.id === ar.id) ))
      this.$store.commit('setLocations', locationList)
    },
    "form.selectedGroups"(){
      this.deleteDisabled = true
      this.$store.commit(this.locationByGroupNameTableDataParam.setQuery, 0)
      if(this.form.selectedGroups.value){
        this.searchGroupContent()
        this.deleteDisabled = false
        this.createdGroup = []
      } else if(this.form.selectedGroups.value == undefined){ // this is for search in dropdown
        this.$store.commit('setLocations', this.locationItemCopy)
        this.resetAll()
        let createdGroupRecent = this.createdGroup
        if (createdGroupRecent.length != 0) { // this will run after newly groip is created to load
          this.$nextTick(() => {
            this.form.selectedGroups =  {
              value: createdGroupRecent.id,
              text: `${createdGroupRecent.name}`,
              is_auto_generated: createdGroupRecent.is_auto_generated
            };
          })
        }
      }
    },
    "groupItemLocation"(){
      if (this.searchedSelectedGroups != '' && this.form.selectedGroups.value != undefined && this.form.selectedGroups.value != 0 ) {
        this.updateGroupDisable = false
      }
    }
  },
  methods: {
    getGroupList(newVal) {
      this.groupItem = [
        ...newVal.map(list => {
          return {
            value: list.id,
            text: `${list.name}`,
            is_auto_generated: list.is_auto_generated
          };
        })
      ];
      this.groupItemCopy = this.groupItem 
    },
    syncAddedGroup(group){
      this.$nextTick(() => {
        this.refreshGroupDropdown()
        this.createdGroup = group
      })
    },
    filterDropdownGroup() {
        if (!this.searchTerm) {
            this.groupItem = this.groupItemCopy;
        }
        this.groupItem = this.groupItem.filter((item) => {
            return (
            item.text.toLowerCase().indexOf(this.searchTerm.toLowerCase()) > -1
            );
        });
    },
    addToGroup(){
        this.groupItemLocation = [...new Set([...this.groupItemLocation,...this.selectedLocation])]
        //
        let locationtem = this.locationItem
        let groupItemLocation = this.groupItemLocation
        this.locationItem = locationtem.filter(ar => !groupItemLocation.find(rm => (rm.id === ar.id) ))
        
        this.$store.commit('setLocations', this.locationItem)
        this.$store.commit('setLocationByGroup', this.groupItemLocation)
        let componentEvent = this.$refs.dataTableComponentOne

        setTimeout(() => {
            this.selectedLocation = []
            componentEvent.clearSelectedFields()     
        }, 200);
    },
    removeToGroup(){
        this.locationItem = [...new Set([...this.locationItem,...this.selectedLocationGroup])]
  
        let locationtem = this.locationItem
        let groupItemLocation = this.groupItemLocation
        this.groupItemLocation = groupItemLocation.filter(ar => !locationtem.find(rm => (rm.id === ar.id) ))
        this.$store.commit('setLocationByGroup', this.groupItemLocation)
        this.$store.commit('setLocations', this.locationItem)
        let componentEvent = this.$refs.dataTableComponentTwo
        setTimeout(() => {
            this.selectedLocationGroup = []
            componentEvent.clearSelectedFields() 
        }, 200);

    },
    showAddDialog() {
      this.$store.commit("showCreateDialog");
    },
    async searchGroupContent(){
      const groupId = this.form.selectedGroups.value
      this.$store.commit(this.locationByGroupNameTableDataParam.setQuery, groupId)
      try {
        await this.$store.dispatch(this.locationByGroupNameTableDataParam.dispatchFunction)
      } catch (error) {
        this.refreshGroupDropdown()
      }
      this.searchedSelectedGroups = this.form.selectedGroups.text
      this.updateRightListDisable = false
      this.updateLeftListDisable = false

      let groupNameHtml = document.getElementById("blinker-effect")
      groupNameHtml.style.transition = 'background-color 2s ease-out'
      groupNameHtml.style.background = '#81C784'
      setTimeout(()=>{
        groupNameHtml.style.background = ''
      },1000)
      if (this.groupItemLocation.length == 0) {
        this.updateGroupDisable = true
        this.$store.commit('setLocations', this.locationItemCopy)
      }
      if (this.form.selectedGroups.is_auto_generated == true) {
        this.updateGroupDisable = true
        this.updateLeftListDisable = true
        this.updateRightListDisable = true
      }
    },
    syncSelectedItemLocation(selectedCollection){
      this.selectedLocation = selectedCollection
    },
    syncSelectedItemLocationFromGroup(selectedCollection){
      this.selectedLocationGroup = selectedCollection
    },
    syncItemLocation(syncItems){
      if (this.locationItemCopy.length == 0){
        this.locationItemCopy = syncItems
      }
      this.locationItem = syncItems
    },
    syncItemLocationGroup(syncItems){
      this.groupItemLocation = syncItems
    },
    resetAll(){
      this.groupItemLocation = []
      this.selectedLocationGroup = []
      this.updateRightListDisable = true
      this.form.selectedGroups = ''
      this.searchedSelectedGroups = ''
      this.updateGroupDisable = true
      this.deleteDisabled = true
      this.$store.commit('setLocationByGroup', [])
    },
    async deleteGroup() {
      let selectedGroupId = this.form.selectedGroups.value;
      if (this.form.selectedGroups.is_auto_generated) {
        swal("Notice", "Auto-Generated Groups cannot be deleted.");
        return false;
      }
      if (
        await this.$refs.confirmationComponent.open(
          "Confirm",
          "Are you sure you want to delete this record?"
        )
      ) {
       
      try {
        await this.$store.commit(this.locationByGroupNameTableDataParam.setQuery, selectedGroupId)
        await this.$store.dispatch(this.locationByGroupNameTableDataParam.deleteFunction)
      } catch (error) {
        this.refreshGroupDropdown()
      }
      this.$nextTick(() => {
        this.refreshGroupDropdown()
        this.resetAll()
        swal("Group Name", "Successfully deleted")
        this.locationItem = this.locationItemCopy
      })
      }
    },
    async refreshGroupDropdown() {
      await this.$store.commit("setDateRange", {});
      await this.$store.dispatch('getLocationsGroups')
      this.$nextTick(() => {
        this.form.selectedGroups = []
        let dropdownGroup = this.$store.getters['getLocationsGroups']
        this.getGroupList(dropdownGroup)
      })
    },
    async saveGroupContent() {
      let selectedGroupId = this.form.selectedGroups.value
      const payload = JSON.parse(
        JSON.stringify({
          locations: this.groupItemLocation
        })
      );
      let response = await UpdateLocationsGroupId(selectedGroupId, payload)

      if (response && response.success == true) {
        swal("Group Name list", "Successfully Updated")
      }
    }
  }
};
</script>

<template>
  <v-card flat>
    <div class="d-flex align-items-center justify-content-center">
         <div class="ml-5 mt-5 grp-loc">
            <v-select
              v-model="form.selectedGroups"
              :items="groupItem"
              label="Groups"
              required
              dense
              outlined
              background-color="#ffffff"
              height="42"
              return-object
              style="position: relative; z-index: 4;"
              :menu-props="{ top: false, offsetY: true }"
            >
                <template v-slot:prepend-item>
                    <v-list-item>
                        <v-list-item-content>
                            <v-text-field
                            v-model="searchTerm"
                            placeholder="Search"
                            @input="filterDropdownGroup"
                            ></v-text-field>
                        </v-list-item-content>
                    </v-list-item>
                </template>
            </v-select>
        </div>
        <div class="ml-3 mb-1">
            <v-btn depressed color="primary"
            @click="showAddDialog">
                <v-icon left>
                    mdi-wrench-outline
                </v-icon>
                Create
            </v-btn>
        </div>
        <div class="ml-3 mb-1 delete-btn">
            <v-btn 
            color="red"
            dark
            :disabled="deleteDisabled"
            @click="deleteGroup">
              <v-icon left>
                  mdi-trash-can-outline
              </v-icon>
              Delete
            </v-btn>
        </div>
    </div>
    
<!-- :show-select -->
    <div class=" d-flex justify-center">
        <div style="width: 500px; display: inline-block;">
          <div class="d-flex align-center justify-space-between">
            <div class="h3 pb-2">All Locations</div>
          </div>
          <div>
              <b-form-input 
                v-model="searchLocation"
                placeholder="Search from all location"
                style="height: auto;"
            ></b-form-input>  
          </div>
          <div>
            <data-table-section
              :tableData="this.locationTableDataParam"
              :customRenderers="this.locationTableDataParam.customRenderers"
              :isSelectEnabled="true"
              ref="dataTableComponentOne"
              @datatableSelectedItem="syncSelectedItemLocation"
              @datatableItems="syncItemLocation"
            >
              <template v-slot:nameparams="{ item }">
                <v-btn text color="primary">
                  {{ item.name }}
                </v-btn>
              </template>
              <template v-slot:streetparams="{ item }">
                {{ item.street }}
              </template>
            </data-table-section>
          </div>
        </div>
        <div class="mt-20 px-10 d-flex flex-column " style="width: 200px; ">
            <div class="mb-5 d-flex justify-center">
                <v-btn color="" 
                depressed
                :disabled="updateRightListDisable"
                @click="addToGroup()">
                    <v-icon >
                        mdi-chevron-right
                    </v-icon>
                    
                </v-btn>
            </div>
            <div class="mb-5 d-flex justify-center">
                <v-btn color=""
                 :disabled="updateLeftListDisable"
                 depressed 
                 @click="removeToGroup()">
                    <v-icon >
                        mdi-chevron-left
                    </v-icon>
                </v-btn>
            </div>
        </div>

        <div style="width: 500px; display: inline-block;">
          <div class="d-flex align-center justify-space-between">
            <div class="h3 pa-2" id="blinker-effect">Group Name: {{searchedSelectedGroups}}</div>
            <div>
              <v-btn
              depressed
              color="primary"
              id="myBtn"
              :disabled="updateGroupDisable"
              @click="saveGroupContent"
              >
                  <v-icon> mdi-content-save-edit-outline</v-icon>
                  Save
              </v-btn>
            </div>
          </div>
          <div>
              <b-form-input 
                v-model="searchLocationFromGroup"
                placeholder="Search location from group"
                style="height: auto;"
            ></b-form-input>  
          </div>
          <data-table-section
            :tableData="this.locationByGroupNameTableDataParam"
            :customRenderers="this.locationByGroupNameTableDataParam.customRenderers"
            :isSelectEnabled="true"
            ref="dataTableComponentTwo"
            @datatableSelectedItem="syncSelectedItemLocationFromGroup"
            @datatableItems="syncItemLocationGroup"
          >
            <template v-slot:nameparams="{ item }">
              <v-btn text color="primary">
                {{ item.name }}
              </v-btn>
            </template>
            <template v-slot:streetparams="{ item }">
              {{ item.street }}
            </template>
          </data-table-section>



            <!-- <v-data-table
              :min-height="300"
              v-model="selectedLocationGroup"
              :headers="headers"
              :items="groupItemLocation"
              item-key="name"
              show-select
              class="elevation-1 mh"
              >
            </v-data-table>    -->
        </div>

    </div>
    
    <!-- orm.selectedGroups -->
    
    <add-group-dialog 
    @watchAddedGroup="syncAddedGroup"></add-group-dialog>
    <confirm-dialog ref="confirmationComponent" />

  </v-card>
  <!-- v-if="add" -->
  
</template>


<style scoped>
.delete-btn .theme--dark.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined){
  background-color: #EBEBE4 !important;
  color: rgba(0, 0, 0, 0.26) !important
}
.grp-loc{
  max-width: 300px;
}
</style>